import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';
import type { CountryRegion } from '@core/locations-types';

import { RegionsHttpClient } from './regions.types';

@Injectable()
export class RecruiteeRegionsHttpClient extends RegionsHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetchRegions(countryCode: string): Observable<CountryRegion[]> {
    return this.httpApi
      .get(`/regions`, { country_code: countryCode })
      .pipe(map(data => data.regions));
  }
}
